import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { APIProvider } from "@vis.gl/react-google-maps";

import { useAuth } from "./context/AuthContext";
import LoadingIndicator from "./screens/common/components/LoadingIndicator";
import ErrorDetail from "./screens/common/ErrorDetail";
import Home from "./screens/Home/Home";
import LeadSearchCreate from "./screens/LeadSearchCreate";
import Login from "./screens/Login";
import Logout from "./screens/Logout";
import ProtectedRoute from "./ProtectedRoute";
import LeadSearchDetail from "./screens/LeadSearchDetail/LeadSearchDetail";
import config from "./config";

export const routes = {
  root: "/",
  login: "/login",
  logout: "/logout",
  leadSearchCreate: "/lead-searches/create",
  leadSearchDetail: (leadSearchId: string) => `/lead-searches/${leadSearchId}`,
  error: (statusCode: number) => `/error/${statusCode}`,
};

export default function Router(): React.JSX.Element {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated === undefined) {
    return <LoadingIndicator />;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path={routes.login} element={<Login />} />
      <Route path="/error/:statusCode" element={<ErrorDetail />} />

      {/* Protected Routes */}
      <Route
        path={routes.root}
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path={routes.logout}
        element={
          <ProtectedRoute>
            <Logout />
          </ProtectedRoute>
        }
      />
      <Route
        path={routes.leadSearchCreate}
        element={
          <ProtectedRoute>
            <APIProvider
              apiKey={config.googleMapsApiKey!}
              version="3.64"
              region="nl"
              language="nl"
              libraries={["geometry"]}
            >
              <LeadSearchCreate />
            </APIProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/lead-searches/:leadSearchId"
        element={
          <ProtectedRoute>
            <APIProvider
              apiKey={config.googleMapsApiKey!}
              version="3.64"
              region="nl"
              language="nl"
              libraries={["marker"]}
            >
              <LeadSearchDetail />
            </APIProvider>
          </ProtectedRoute>
        }
      />

      {/* Catch-All Route */}
      <Route path="*" element={<Navigate to={routes.error(404)} replace />} />
    </Routes>
  );
}
